const url = '/wp-admin/admin-ajax.php';
import _ from 'lodash';
const action = 'wish_list_ajax_response';

$(function () {
  // gather wish list buttons
  $('.product-like').each(function (i, button) {
    let $button = $(button);
    let modelId = $button.data('model-id');

    // add class active if model is in wish list
    isInWishList(modelId).then(wished => wished && $button.find('svg').addClass('!fill-black'));

    // add click event listener
    $button.off('click touchstart').on('click touchstart', () => {
      let fct = $button.find('svg').hasClass('!fill-black') ? 'remove' : 'add';
      manageWishList(fct, modelId, $button);
    });
  });

  generateList();

  $('#heartDropdown').on('click touchstart', function (e) {
    e.preventDefault();
    $('#heartDropdownMenu').toggleClass('hidden');
    $('#heartDropdown svg').toggleClass('fill-none !fill-linen-light');
  });

  // Close heartDropdownMenu when clicking outside
  $(document).on('mousedown touchstart', function (e) {
    const $menu = $('#heartDropdownMenu');
    const $dropdown = $('#heartDropdown');
    if (!$menu.hasClass('hidden')) {
      // If click is outside menu and dropdown button
      if (
        !$menu.is(e.target) &&
        $menu.has(e.target).length === 0 &&
        !$dropdown.is(e.target) &&
        $dropdown.has(e.target).length === 0
      ) {
        $menu.addClass('hidden');
        $dropdown.find('svg').removeClass('!fill-linen-light').addClass('fill-none');
      }
    }
  });
});

/**
 * Remove item from wish list and close menu
 * @param {MouseEvent} e
 * @returns {void}
 */
function onClickDropdownItem(e) {
  e.stopPropagation();

  let modelId = $(e.target).closest('.wishlist-item').data('model-id');

  manageWishList('remove', modelId, $(`.product-like[data-model-id=${modelId}]`));
  //$(e.target).closest('.dropdown-menu').dropdown('hide');
}

/**
 * Manage wish list actions
 * @param {string} action - the action to execute
 * @param {number} model - id of the model to add or remove from list
 * @param {jQuery} trigger - the button on witch we want to toggle class active
 * @returns {void}
 */
function manageWishList(action, model, trigger) {
  editWishList(action, model).then(() => {
    action === 'add'
      ? trigger.find('svg').addClass('!fill-black')
      : trigger.find('svg').removeClass('!fill-black');
    generateList();
  });
}

/**
 * Fetch wish list and populate list in dropdown menu in header
 * @return {void}
 */
function generateList() {
  getWishList().then(list => {
    // add a badge to the heart icon with number of items in wish list
    let $badge = $('#heartDropdown').find('.wishlist-badge');
    if (list.length > 0) {
      if ($badge.length === 0) {
        $badge = $('<span></span>')
          .addClass(
            'wishlist-badge font-display absolute -top-2 -right-1 bg-linen-light text-back text-[12px] font-bold leading-none w-4 h-4 rounded-full flex items-center justify-center',
          )
          .appendTo($('#heartDropdown').css('position', 'relative'));
      }
      $badge.text(list.length);
    } else {
      $badge.remove();
    }
    
    const menuIds = ['heartDropdownMenu'];

    menuIds.forEach(id => {
      let menu = $(`#${id}`);

      // empty the menu so we can easily populate it
      menu.empty();

      // Load wishlist item template from DOM
      console.log('Loading wishlist template for menu:', $('#wishlist-item-template'));
      let tplHtml = $('#wishlist-item-template').html();
      tplHtml = typeof tplHtml === 'string' ? tplHtml.trim() : '';
      const wishlistItemTemplate = _.template(tplHtml);
      console.log('Generating wishlist for menu:', id);
      console.log('Rendering wishlist with items:', list);
      // Render all items in one template pass
      let $dropdownItems = $(wishlistItemTemplate({ items: list }));
      menu.append($dropdownItems);
      // Attach event listeners to all delete buttons
      setTimeout(() => {
        menu.find('.deleteWishList')
          .off('click touchstart')
          .on('click touchstart', onClickDropdownItem);
      }, 500);
    });
  });
}

/**
 * Add or remove model from favorites
 * @param {string} fct - Action to trigger (add, remove, is_favorite, fetch_all)
 * @param {number} id - The model id
 * @return {Promise<any>}
 */
function editWishList(fct, id) {
  console.log('editWishList called with fct:', fct, 'id:', id);
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      data: { action, fct, id },
      method: 'POST',
      dataType: 'json',
      success: () => resolve(),
      error: error => reject(error),
    });
  });
}

/**
 * Check if model is in wish list
 * @param {number} id - The model id
 * @returns {Promise<boolean>}
 */
function isInWishList(id) {
  let fct = 'is_favorite';
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      data: { action, fct, id },
      method: 'POST',
      dataType: 'json',
      success: data => resolve(data.is_favorite),
      error: error => reject(error),
    });
  });
}

/**
 * Get user's wish list
 * @returns {Promise<[]>}
 */
function getWishList() {
  let fct = 'fetch_all';
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      data: { action, fct },
      method: 'POST',
      dataType: 'json',
      success: data => resolve(data.wishlist),
      error: error => reject(error),
    });
  });
}
